import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const BuyCryptoChooseAssetsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  ${({ theme }) => theme.media.laptop`
      margin-top: -1rem;
  `};
`;

export const BodyLoader = styled(ContentLoader)`
  height: 7.5rem;
  min-width: 13.5rem;
  background-color: ${({ theme }) => theme.colors.text.interactive};
  border-radius: ${({ theme }) => theme.borderRadius.high};

  ${({ theme }) => theme.media.laptop`
      height: 7.5rem;
      width: 100%;
  `};
`;

type loadersProps = {
  shouldShowCircleIcon: boolean;
};

export const AssetIcon = styled.circle<loadersProps>`
  r: 2rem;
  cy: 3rem;
  cx: ${({ shouldShowCircleIcon }) => (shouldShowCircleIcon ? '17%' : '10%')};

  ${({ theme, shouldShowCircleIcon }) => theme.media.laptop`
    cy: 5rem;
    r: 2rem;
    cx: ${
      (shouldShowCircleIcon
        ? '9rem'
        : '4rem') as unknown as TemplateStringsArray
    };
  `};
`;

export const CircleIcon = styled.circle`
  r: 1.4rem;
  cx: 1.5rem;
  cy: 3.4rem;

  ${({ theme }) => theme.media.laptop`
      cx: 3.7rem;
      cy: 5rem;
      r: 1.4rem;
  `};
`;

export const AssetName = styled.rect<loadersProps>`
  height: 1.8rem;
  width: 7rem;

  y: 1.4rem;
  x: ${({ shouldShowCircleIcon }) => (shouldShowCircleIcon ? '26%' : '16%')};

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme, shouldShowCircleIcon }) => theme.media.laptop`
    y: 3rem;
    x: ${
      (shouldShowCircleIcon
        ? '12rem'
        : '7rem') as unknown as TemplateStringsArray
    }
     height: 1.8rem;
  `};
`;

export const AssetCode = styled.rect<loadersProps>`
  height: 1.2rem;
  width: 4rem;

  x: ${({ shouldShowCircleIcon }) => (shouldShowCircleIcon ? '26%' : '16%')};
  y: 3.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme, shouldShowCircleIcon }) => theme.media.laptop`
    y: 5.5rem;
     x: ${
       (shouldShowCircleIcon
         ? '12rem'
         : '7rem') as unknown as TemplateStringsArray
     }
     height: 1.6rem;
  `};
`;

export const Price = styled.rect`
  height: 1.8rem;
  width: 9rem;

  x: 67%;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 28rem;
    y: 3rem;
  `};
`;

export const Change = styled.rect`
  height: 1.6rem;
  width: 6rem;

  x: 74%;
  y: 3.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 31rem;
    y: 5.5rem;
  `};
`;

export const ArrowIcon = styled.circle`
  r: 0.8rem;
  cx: 96%;
  cy: 3.4rem;

  ${({ theme }) => theme.media.laptop`
      cx: 39.7rem;
      cy: 5rem;
      r: 1rem;
  `};
`;
